import React from "react";

import { Button, buttonStyle } from "../Button";

type PaginationLinkProps = {
    active?: boolean;
} & Pick<React.ComponentProps<typeof Button>, "size"> &
    React.ComponentProps<"a">;

export function PaginationLink({
    className,
    active,
    size = "icon",
    ...props
}: PaginationLinkProps) {
    return (
        <a
            aria-current={active ? "page" : undefined}
            data-slot="pagination-link"
            data-active={active}
            className={buttonStyle({
                variant: active ? "default" : "text",
                size,
                className,
            })}
            {...props}
        />
    );
}
